import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useSelector } from 'react-redux';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { useDispatch } from 'react-redux';
import { getAppraisalCyclicleFillingDatas } from '../../../../redux/features/appraisalSlice';
import FormParent from './FormParent';
import { debounce } from 'lodash';
import { Icon } from '@iconify/react/dist/iconify.js';

const AddEvaluationManagerFormLanding = ({userID, id, title, afterFormSubmissionApi, AfterFormdispatchParams,viewOnly ,extraDisable=false,isAdmin=false}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { loading, formFillingDatas } = useSelector((state) => state.appraisal);
  const dispatchParams = {
    id: id,
    userID:userID,
    isMangerTrue:true
  };

  useEffect(() => {
    if (open) {
      const debouncedDispatch = debounce(() => {
        dispatch(getAppraisalCyclicleFillingDatas(dispatchParams));
      }, 100);

      debouncedDispatch();

      return () => {
        debouncedDispatch.cancel();
      };
    }
  }, [open, id]);

  return (
    <Box>
      <GlobalDialog
        open={open}
        setOpen={setOpen}
        fullScreen
        title={title}
        popupButton={
          <Button
           startIcon={<Icon icon={viewOnly?'mdi:eye':"ix:hourglass-start"} height={20} width={20} />}
            size="small"
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{ boxShadow: 'none',color:'white'}}
            color="primary"
            disabled={extraDisable}
          >
          {isAdmin?'View':viewOnly?"View Manager-Appraisal":"Start Manager-Appraisal"}  
          </Button>
        }
        closeButton={true}
        content={
          <>
            {open ? (
              <FormParent
                loading={loading}
                managerView={true}
                data={formFillingDatas}
                appraisalCycleId={id}
                api={afterFormSubmissionApi}
                dispatchParams={AfterFormdispatchParams}
                formClose={setOpen}
                viewOnly={viewOnly}
                userID={userID}
                isAdmin={isAdmin}
              />
            ) : null}
          </>
        }
      />
    </Box>
  );
};

export default AddEvaluationManagerFormLanding;
